import React, { type FunctionComponent } from 'react'
import { Text } from '@retailer-platform/shared-components'
import { FormattedDate } from 'react-intl'
import { useDomainMessages } from 'domains/collections/utils/domain/intl'
import { type CollectionDatum } from 'domains/collections/types/collections.types'

interface Props {
  collection: CollectionDatum
}

export const CollectionsListDatesCell: FunctionComponent<Props> = ({ collection }) => {
  const noDateMessages = useDomainMessages({
    start: 'collectionsDomain.list.activeDates.noStart',
    end: 'collectionsDomain.list.activeDates.noEnd',
  })

  return (
    <Text>
      {collection.startDate ? (
        <FormattedDate timeZone="utc" value={collection.startDate} />
      ) : (
        noDateMessages.start
      )}
      {' - '}
      {collection.endDate ? (
        <FormattedDate timeZone="utc" value={collection.endDate} />
      ) : (
        noDateMessages.end
      )}
    </Text>
  )
}
